import { FormattedMessage, useIntl, defineMessages } from 'react-intl'
import { useQuery, gql } from '@apollo/client'

import { isEmpty } from 'lodash'

import { Select } from 'components/v2/Select'

const GET_COMPANY_ROLES_AUTOCOMPLETE = gql`
  query GetCompanyRolesAutocomplete($limit: Int!) {
    companyRoles(pagination: { size: $limit, page: 0 }) {
      items {
        id
        name
      }
    }
  }
`

const messages = defineMessages({
  selectRole: {
    id: 'companyRoles.select.placeholder',
    defaultMessage: 'Select a role'
  }
})

export const SelectCompanyRole = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const { data } = useQuery(GET_COMPANY_ROLES_AUTOCOMPLETE, {
    variables: {
      limit: 1000
    }
  })

  const getCompanyRoles = (): TSFixMe => {
    if (data && data.companyRoles && !isEmpty(data.companyRoles.items)) {
      return data.companyRoles.items
    }

    return []
  }

  return (
    <Select
      id={props.id}
      value={props.companyRoleId}
      // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
      getTagLabel={({ name }: TSFixMe): TSFixMe => name}
      onChange={props.onChange}
      onBlur={props.onBlur}
      label={<FormattedMessage id="dictionary.companyRole" defaultMessage="Company Role" />}
    >
      <option value="">{intl.formatMessage(messages.selectRole)}</option>

      {getCompanyRoles().map((role: TSFixMe): TSFixMe => {
        return (
          <option key={role.id} value={role.id}>
            {role.name}
          </option>
        )
      })}
    </Select>
  )
}
